import { useIsMediaQuery } from "@/shared";
import {
  CalendarComponentState
} from "@/shared/interfaces";
import { usePlanificadorStore } from "@/store/erp";
import { EventContentArg } from "@fullcalendar/core/index.js";
import esLocale from "@fullcalendar/core/locales/es";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayjs from "dayjs";
import { useState } from "react";
import CustomBlockTimeModal from "./CustomBlockTimeModal";
import CustomUnblockTimeModal from "./CustomUnblockTimeModal";
import "./FullCalendarComponente.css";
import MultipleSlotsModal from "./MultipleSlotsModal";

interface SelectableProps {
  planificadorId: string;
}

export function FullCalendarComponent({ planificadorId }: SelectableProps) {
  /////* local state -----------------
  const [openMiltipleSlotsModal, setOpenMiltipleSlotsModal] =
    useState<CalendarComponentState["bool"]>(false);

  //const [events] = useState<PlanificadorEvent[]>(transformarAEventosFullCalendar(timeMap));

  ///* Store
  const handleChangeDatePicker = usePlanificadorStore(
    (s) => s.handleChangeDatePicker
  );
  const valueDatePicker = usePlanificadorStore((s) => s.valueDatePicker);
  const setSelectedEventsArray = usePlanificadorStore(
    (s) => s.setSelectedEventsArray
  );
  
  const events = usePlanificadorStore((s) => s.events);

  ///* Hook
  const isMobile = useIsMediaQuery("sm");

  ///* Handle
  const handleSelect = (selectInfo: any) => {

    
    const selectedStart = new Date(selectInfo.start);
    const selectedEnd = new Date(selectInfo.end);

    const filteredEvents = events.filter((event) => {
      const eventStart = new Date(event.start);
      const eventEnd = new Date(event.end);

      return (
        (eventStart >= selectedStart && eventStart < selectedEnd) ||
        (eventEnd > selectedStart && eventEnd <= selectedEnd) ||
        (eventStart <= selectedStart && eventEnd >= selectedEnd)
      );
    });

    console.log('accion_select', filteredEvents);

    setSelectedEventsArray(filteredEvents);
    setOpenMiltipleSlotsModal(true);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView={isMobile ? "timeGridDay" : "timeGridWeek"}
          events={events}
          locales={[esLocale]} // Configura el locale a español
          datesSet={(date) => {
            handleChangeDatePicker(dayjs(date.start));
          }}
          initialDate={valueDatePicker?.toDate()} // Establece la fecha por defecto aquí
          scrollTime="07:00:00"
          //slotMinTime={{ hour: 7, minute: 0 }}
          //slotMaxTime={{ hour: 23, minute: 0 }}
          slotMinTime={{ hour: 0, minute: 0 }}
          slotMaxTime={{ hour: 23.5, minute: 0 }}
          allDaySlot={false}
          eventContent={(eventInfo) => renderEventContent(eventInfo)}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "timeGridWeek,timeGridDay",
          }}
          editable={false} // Desactiva el arrastre de eventos
          droppable={false} // Desactiva la posibilidad de soltar eventos
          eventResizableFromStart={false} // Desactiva el redimensionamiento
          selectable={true} // Permite seleccionar un rango de horas
          select={handleSelect} // Recupera los eventos dentro del rango seleccionado
        />
      </div>

      {/* ------ multiple select slots - events ------ */}
      {openMiltipleSlotsModal && (
        <MultipleSlotsModal
          open={openMiltipleSlotsModal}
          onClose={() => setOpenMiltipleSlotsModal(false)}
          planificadorId={planificadorId}
        />
      )}

      {/* ------ custom block/umbloc modal ------ */}
      <CustomBlockTimeModal planificadorId={planificadorId} />
      <CustomUnblockTimeModal planificadorId={planificadorId} />
    </>
  );
}

// a custom render function
function renderEventContent(eventInfo: EventContentArg) {
  return (
    <div className="insideStyle">
      <span>
        <b>{eventInfo.timeText}</b>
      </span>
      <span>{eventInfo.event.title}</span>
      <span className="reason">{eventInfo.event.extendedProps.motivo}</span>
      <span className="username">{eventInfo.event.extendedProps.username}</span>
      {/* <span className="reason">{eventInfo.event.extendedProps.fecha_hora_limite}</span> */}
    </div>
  );
}
